(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["module-product-360"]) return;
  try {
    
  $(document).ready(function() {
    $(document).scroll(function() {
      var mq = window.matchMedia( "(max-width: 720px)" );
      if (mq.matches) {
        var y = $(this).scrollTop();
        if (y > 1200) {
          $('.cta-shadow').addClass('sticky-cta');
        } else {
          $('.cta-shadow').removeClass('sticky-cta');
        }
      }
      else {
        var y = $(this).scrollTop();
        if (y > 900) {
          $('.cta-shadow').addClass('sticky-cta');
        } else {
          $('.cta-shadow').removeClass('sticky-cta');
        }
      }
    });
    // Scroll top
    $(".scroll-top").click(function() {
      var mq = window.matchMedia( "(max-width: 720px)" );
      if (mq.matches) {
        $('html, body').animate({
          scrollTop: $("#product-top").offset().top
        }, 1000);
      }
      else {
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-product"]) return;
  try {
    
  $(document).ready(function() {
    $(document).scroll(function() {
      var mq = window.matchMedia( "(max-width: 720px)" );
      if (mq.matches) {
        var y = $(this).scrollTop();
        if (y > 1200) {
          $('.cta-shadow').addClass('sticky-cta');
        } else {
          $('.cta-shadow').removeClass('sticky-cta');
        }
      }
      else {
        var y = $(this).scrollTop();
        if (y > 900) {
          $('.cta-shadow').addClass('sticky-cta');
        } else {
          $('.cta-shadow').removeClass('sticky-cta');
        }
      }
    });
    // Scroll top
    $(".scroll-top").click(function() {
      var mq = window.matchMedia( "(max-width: 720px)" );
      if (mq.matches) {
        $('html, body').animate({
          scrollTop: $("#product-top").offset().top
        }, 1000);
      }
      else {
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

})();
